import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import HeaderContainer from './Header/HeaderContainer';
import Footer from './Footer';

import 'normalize.css';
import './layout.css';
import '@fortawesome/fontawesome-svg-core/styles.css';

const Layout = ({ children }) => (
  <>
    <Helmet>
      <title>Cookie Policy | Endtest</title>
      <meta name="description" content="Details about Cookies on Endtest"/>
      <meta name="google-site-verification" content="nCGQdyXu1gfRfsotN5netrBDt-rsu92IP7VzRa-lb7E" />

      <meta property="og:title" content="Cookie Policy | Endtest"/>
      <meta property="og:description" content="Details about Cookies on Endtest"/>
      <meta property="og:image" content="https://endtest.io/images/endtest_black_logo_og.png"/>

      <meta property="og:type" content="website"/>
      <meta property="og:site_name" content="Endtest"/>

      <meta name="twitter:title" content="Cookie Policy | Endtest"/>
      <meta name="twitter:description" content="Details about Cookies on Endtest"/>
      <meta name="twitter:image" content="https://endtest.io/images/endtest_black_logo_og.png"/>
      <meta name="twitter:card" content="summary_large_image"/>

      <script type="text/javascript" charset="UTF-8" src="//ca-eu.cookie-script.com/s/5de86bf092b7f19b6cf7b4792c4565fa.js"></script>
      <script src="/scripts/driftt.js" />
      <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/21783701.js"></script>
    </Helmet>
    <HeaderContainer />
    <main className="contentWrapper">{children}</main>
    <Footer />

    <script src="/scripts/google-analytics.js" />
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
